import { debounce, isElement, forEach } from 'lodash';
import mustache from 'mustache';

import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { stringToNode } from '../../01-helpers/utilities/node';
import { publish } from '../../01-helpers/event-manager';
import { ADD_TO_CART } from '../../02-const/event-names';
import addToCart from '../../03-api/shop/addtocart';

/**
 * this module with add a product to the Cart
 * 
 * 1) get producttype/id
 * 2) get amount
 * 3) add to cart
 * 
 * CART MODEL:
 * {
 *      "ProductReference": "{String}",
 *      "Quantity":"{Integer}"
 * }
 * 
 **/

const moduleName = 'add-to-cart',
    selectors = {
        base: `.js-${moduleName}`,
        variant: `.js-${moduleName}-variant`,
        amount: `.js-${moduleName}-amount`,
        feedback: `.js-${moduleName}-feedback`
    },
    cart = {
        productReference: null,
        quantity: 0
    },
    className = {
        invert: 'c-feedback-text--invert'
    },
    translationsKey = {
        key: 'translations',
        added: 'AddedToCart',
        failed: 'Error'
    },
    data = {
        theme: 'theme'
    },
    template = {
        added: `<span class="c-feedback-text c-feedback-text--success">{{ message }}</span>`,
        failed: `<span class="c-feedback-text c-feedback-text--error">{{ message }}</span>`
    };

function renderTemplate(template, item) {
    return mustache.render(template, item);
}

export default class AddToCart {
    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }


    _resetContainer() {
        clearTimeout(this.timeout);
        this.feedback.innerHTML = '';
    }

    //========= Event Handling ==========//

    _onSubmitHandler(e) {
        e.preventDefault();
        // get product version
        cart.productReference = this.variant?.value,
        // get amount
        cart.quantity = this.baseElement.querySelector(selectors.amount).value;

        this._resetContainer();

        if (cart.productReference !== null && cart.quantity > 0) {
            // add product to cart
            addToCart(cart)
                .then((response) => {
                    publish(ADD_TO_CART);
                    // get message container and add translation text
                    const element = stringToNode(renderTemplate(template.added,
                        {
                            message: this.translations[translationsKey.added]
                        }
                    ));
                    if (this.feedback.dataset[data.theme] === 'invert') {
                        element.classList.add(className.invert);
                    }
                    this.feedback.appendChild(element)

                    this.timeout = setTimeout(() => {
                        this.feedback.removeChild(element);
                    }, 5000);
                })
                .catch((error) => {
                    // get message container and add translation text
                    this.feedback.appendChild(stringToNode(renderTemplate(template.failed,
                        {
                            message: this.translations[translationsKey.failed]
                        }
                    )));
                });   
        }
    }

    _bindEvents() {
        this.baseElement.addEventListener('submit', (event) => this._onSubmitHandler(event));
    }

    //===================================//

    //========= Initialization ==========//

    _configure(baseElement) {
        this.baseElement = baseElement;
        this.variant = this.baseElement.querySelector(selectors.variant);
        this.feedback = this.baseElement.querySelector(selectors.feedback);
        this.timeout = null;
    }

    _setup() {
        this.translations = getPageOptions(translationsKey.key);
        this._bindEvents();
    }

    //===================================//
}

const initAddToCart = () => {
    forEach(document.querySelectorAll(selectors.base), (addToCartElement) => {
        new AddToCart(addToCartElement);
    });
};

initAddToCart();